import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tcm-chat-icon-jktl",
  "use": "icon-tcm-chat-icon-jktl-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 28 28\" id=\"icon-tcm-chat-icon-jktl\">\r\n  <g transform=\"translate(-305.986 -81.986)\">\r\n    <path class=\"b\" d=\"M72.2,120.861H65.348a7.888,7.888,0,0,1,12.83-9.107,7.888,7.888,0,0,1,12.712,9.3H81.2a.567.567,0,0,0-.535.378l-.788,2.238-6.1-7.328a.567.567,0,0,0-1,.363v3.592A.566.566,0,0,1,72.2,120.861Zm7.65,5.449-5.371-6.446V122a.566.566,0,0,1-.566.566H66.755c.047.041.091.084.138.128l11.286,11.286,11.227-11.227h-7a.567.567,0,0,0-.535.378l-1.054,2.995A.565.565,0,0,1,79.851,126.31Zm0,0\" transform=\"translate(241.807 -25.449)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tcm-chat-icon-jktl.svg
// module id = 2t5E
// module chunks = 10